(function (root) {
  'use strict';

  const BP_DESKTOP = 1200;

  const desktopQuery = root.matchMedia ? root.matchMedia('(min-width: ' + BP_DESKTOP + 'px)') : null;

  function isDesktop() {
    return !!(desktopQuery && desktopQuery.matches);
  }

  function columnCount(grid) {
    const classes = grid ? grid.className : '';
    if (isDesktop()) {
      const desktopMatch = classes.match(/row-cols-(?:xl|lg)-(\d+)/);
      return desktopMatch ? parseInt(desktopMatch[1], 10) : 4;
    }
    const mobileMatch = classes.match(/row-cols-(\d+)(?!\w)/);
    return mobileMatch ? parseInt(mobileMatch[1], 10) : 2;
  }

  function bannerColumns(el, cols) {
    let width;
    if (isDesktop()) {
      width = parseInt(el.dataset.desktopSpan, 10) || 1;
    } else {
      const span = el.dataset.mobileSpan;
      if (span === 'hidden') return 0;
      width = span === 'half' ? 1 : cols;
    }
    return width > cols ? cols : width;
  }

  function spanOf(el, cols) {
    if (el.classList.contains('bantoa-plp-row')) {
      return { w: cols, h: 1, kind: 'bantoa', el: el };
    }
    if (el.hasAttribute('data-plp-banner')) {
      return { w: bannerColumns(el, cols), h: 1, kind: 'banner', el: el };
    }
    if (!el.classList.contains('col') && !el.hasAttribute('data-collection-product')) {
      return { w: 0, h: 1, kind: 'other', el: el };
    }
    const desktop = isDesktop();
    const big = desktop
      ? el.classList.contains('plp-big-card--desktop')
      : el.classList.contains('plp-big-card--mobile');
    let target = null;
    if (big) {
      target = desktop && el.dataset.plpBigCardTarget === 'right' ? 2 : 0;
    }
    return { w: big ? 2 : 1, h: big ? 2 : 1, kind: 'product', target: target, el: el };
  }

  function key(row, col) {
    return row + ':' + col;
  }

  function fits(occupied, row, col, w, h) {
    for (let r = row; r < row + h; r++) {
      for (let c = col; c < col + w; c++) {
        if (occupied[key(r, c)]) return false;
      }
    }
    return true;
  }

  function run(items, cols, onPlaced) {
    const occupied = {};
    const placed = [];
    let row = 0;
    let col = 0;
    let maxRow = -1;

    for (let i = 0; i < items.length; i++) {
      const w = items[i].w > cols ? cols : items[i].w;
      const h = items[i].h || 1;
      if (w <= 0) {
        placed.push(null);
        continue;
      }
      let skipped = 0;
      while (true) {
        if (col + w > cols) {
          for (let c = col; c < cols; c++) {
            if (!occupied[key(row, c)]) skipped++;
          }
          row++;
          col = 0;
        }
        if (fits(occupied, row, col, w, h)) break;
        if (!occupied[key(row, col)]) skipped++;
        col++;
      }
      for (let r = row; r < row + h; r++) {
        for (let cc = col; cc < col + w; cc++) {
          occupied[key(r, cc)] = true;
        }
      }
      if (row + h - 1 > maxRow) maxRow = row + h - 1;
      placed.push({ col: col, row: row, w: w, h: h, skipped: skipped });
      col += w;
      if (onPlaced) onPlaced(i, { col: col, row: row, maxRow: maxRow, occupied: occupied });
    }

    return { placed: placed, cursor: { col: col, row: row } };
  }

  function simulate(items, cols) {
    return run(items, cols, null);
  }

  function columnAfter(items, cols) {
    const cursor = simulate(items, cols).cursor;
    return cursor.col >= cols ? 0 : cursor.col;
  }

  function fitsNext(items, w, cols) {
    const probe = items.concat([{ w: w, h: 1, kind: 'banner' }]);
    const placed = simulate(probe, cols).placed;
    const last = placed[placed.length - 1];
    return !!last && last.skipped === 0;
  }

  function rowEndFlags(items, cols) {
    const flags = [];
    run(items, cols, function (i, state) {
      if (items[i].kind !== 'product') return;
      let full = true;
      for (let c = 0; c < cols; c++) {
        if (!state.occupied[key(state.row, c)]) {
          full = false;
          break;
        }
      }
      flags.push(full && state.maxRow === state.row);
    });
    return flags;
  }

  function nextMove(items, cols, ignore) {
    const placed = simulate(items, cols).placed;
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (typeof item.target !== 'number' || !placed[i]) continue;
      if (ignore && ignore.indexOf(item) !== -1) continue;
      const target = item.target >= cols ? 0 : item.target;
      const p = placed[i];
      if (p.col === target && p.skipped === 0) continue;
      const k = p.skipped > 0 ? p.skipped : (target - p.col + cols) % cols;
      let remaining = k;
      let afterIndex = -1;
      for (let j = i + 1; j < items.length; j++) {
        if (items[j].kind === 'product' && items[j].w === 1) {
          remaining--;
          if (remaining === 0) {
            afterIndex = j;
            break;
          }
        }
      }
      return { index: i, k: k, afterIndex: afterIndex };
    }
    return null;
  }

  function snapAll(items, cols) {
    const out = items.slice();
    const stuck = [];
    for (let guard = 0; guard < out.length * 2 + 1; guard++) {
      const move = nextMove(out, cols, stuck);
      if (!move) break;
      if (move.afterIndex < 0) {
        stuck.push(out[move.index]);
        continue;
      }
      const moved = out.splice(move.index, 1)[0];
      out.splice(move.afterIndex, 0, moved);
    }
    return out;
  }

  const api = {
    BP_DESKTOP: BP_DESKTOP,
    isDesktop: isDesktop,
    columnCount: columnCount,
    bannerColumns: bannerColumns,
    spanOf: spanOf,
    simulate: simulate,
    columnAfter: columnAfter,
    fitsNext: fitsNext,
    rowEndFlags: rowEndFlags,
    nextMove: nextMove,
    snapAll: snapAll,
  };

  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  root.plpGridLayout = api;
})(typeof window !== 'undefined' ? window : globalThis);
